import {PatientCommandParams} from "./PatientCommandParams";
import {Command} from "./Command";

export const GetPatientInsuranceSP = (params: PatientCommandParams): Command => {
    return {
        operation: 'VyhladajPoisteniaSP_GW_v1',
        params
    }
}